define('OutSystems/ClientRuntime/modules/LogTable/LogDatabaseStorage',["require", "exports", "tslib", "../../Logger", "./LogTableExtraInfoUpgrader", "./LogTableInfo", "./LogTableInitializer"], function (require, exports, tslib_1, Logger, LogTableExtraInfoUpgrader_1, LogTableInfo_1, LogTableInitializer_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getMaxRecords = void 0;
    var getMaxRecords = function () { return 1000; };
    exports.getMaxRecords = getMaxRecords;
    var LogDatabaseStorage = (function () {
        function LogDatabaseStorage(db) {
            this.db = db;
            this.count = 0;
            Logger.trace(this, "Registering initializer for entity Log Table info table.");
            db.registerInitializer(LogTableInitializer_1.default);
            db.registerInitializer(LogTableExtraInfoUpgrader_1.default);
        }
        LogDatabaseStorage.prototype.initialize = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    return [2, this.db.executeReadTransaction(function (tx) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var allRecords;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, tx.existsTable(LogTableInfo_1.default)];
                                    case 1:
                                        if (!!(_a.sent())) return [3, 2];
                                        this.count = 0;
                                        return [3, 4];
                                    case 2: return [4, tx.getAllRecords(LogTableInfo_1.default)];
                                    case 3:
                                        allRecords = _a.sent();
                                        this.count = allRecords.length;
                                        _a.label = 4;
                                    case 4: return [2];
                                }
                            });
                        }); })];
                });
            });
        };
        LogDatabaseStorage.prototype.getCount = function () {
            return this.count;
        };
        LogDatabaseStorage.prototype.insertEntity = function (transaction, logMessage) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var newRecord;
                var _a;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            newRecord = (_a = {},
                                _a[LogTableInfo_1.LOG_FIELDS.Instant] = logMessage.instant,
                                _a[LogTableInfo_1.LOG_FIELDS.LogType] = logMessage.logType,
                                _a[LogTableInfo_1.LOG_FIELDS.Message] = logMessage.message,
                                _a[LogTableInfo_1.LOG_FIELDS.MessageType] = logMessage.messageType,
                                _a[LogTableInfo_1.LOG_FIELDS.ModuleName] = logMessage.moduleName,
                                _a[LogTableInfo_1.LOG_FIELDS.Stack] = logMessage.stack,
                                _a[LogTableInfo_1.LOG_FIELDS.ExtraInfo] = JSON.stringify(logMessage.extra),
                                _a);
                            return [4, transaction.insertRecord(LogTableInfo_1.default, newRecord)];
                        case 1:
                            _b.sent();
                            this.updateCount(1);
                            return [2];
                    }
                });
            });
        };
        LogDatabaseStorage.prototype.internalCountLogs = function (transaction) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var allRecords;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, transaction.getAllRecords(LogTableInfo_1.default)];
                        case 1:
                            allRecords = _a.sent();
                            return [2, allRecords.length];
                    }
                });
            });
        };
        LogDatabaseStorage.prototype.updateCount = function (change) {
            this.count += change;
            this.count = Math.max(this.count, 0);
        };
        LogDatabaseStorage.prototype.countLogs = function () {
            var _this = this;
            return this.db.executeReadTransaction(function (transaction) { return _this.internalCountLogs(transaction); }, false);
        };
        LogDatabaseStorage.prototype.internalDiscardLogsByType = function (transaction, count, numberLogsToDiscard, type) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var internalCount, logs, i;
                var _a;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            internalCount = count;
                            return [4, transaction.findRecords(LogTableInfo_1.default, (_a = {}, _a[LogTableInfo_1.LOG_FIELDS.LogType] = type, _a))];
                        case 1:
                            logs = (_b.sent());
                            i = 0;
                            _b.label = 2;
                        case 2:
                            if (!(i < Math.min(numberLogsToDiscard, logs.length))) return [3, 5];
                            return [4, transaction.removeRecord(LogTableInfo_1.default, logs[i].$KEY)];
                        case 3:
                            _b.sent();
                            internalCount++;
                            _b.label = 4;
                        case 4:
                            i++;
                            return [3, 2];
                        case 5: return [2, internalCount];
                    }
                });
            });
        };
        LogDatabaseStorage.prototype.discardLogs = function (transaction, totalRowsToDelete) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var count, numberLogsToDiscard, _a, _b, _c;
                return tslib_1.__generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            count = 0;
                            numberLogsToDiscard = totalRowsToDelete;
                            _a = count;
                            return [4, this.internalDiscardLogsByType(transaction, count, numberLogsToDiscard, Logger.LogTypes.Trace)];
                        case 1:
                            count = _a + _d.sent();
                            if (!(count < totalRowsToDelete)) return [3, 3];
                            numberLogsToDiscard -= count;
                            _b = count;
                            return [4, this.internalDiscardLogsByType(transaction, count, numberLogsToDiscard, Logger.LogTypes.General)];
                        case 2:
                            count = _b + _d.sent();
                            _d.label = 3;
                        case 3:
                            if (!(count < totalRowsToDelete)) return [3, 5];
                            numberLogsToDiscard -= count;
                            _c = count;
                            return [4, this.internalDiscardLogsByType(transaction, count, numberLogsToDiscard, Logger.LogTypes.Error)];
                        case 4:
                            count = _c + _d.sent();
                            _d.label = 5;
                        case 5:
                            this.updateCount(-count);
                            return [2];
                    }
                });
            });
        };
        LogDatabaseStorage.prototype.internalWriteLog = function (logMessages) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    return [2, this.db.executeTransaction(function (transaction) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var numberLogsToDiscard, allInsertions;
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(this.count + logMessages.length >= exports.getMaxRecords())) return [3, 2];
                                        numberLogsToDiscard = this.count + logMessages.length - exports.getMaxRecords();
                                        return [4, this.discardLogs(transaction, numberLogsToDiscard)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        allInsertions = logMessages.map(function (record) { return _this.insertEntity(transaction, record); });
                                        return [4, Promise.all(allInsertions)];
                                    case 3:
                                        _a.sent();
                                        return [2];
                                }
                            });
                        }); }, false)];
                });
            });
        };
        LogDatabaseStorage.prototype.writeLog = function (logMessage) {
            return this.internalWriteLog([logMessage]);
        };
        LogDatabaseStorage.prototype.writeLogBatch = function (logBatch) {
            if (logBatch.length > exports.getMaxRecords()) {
                var logsToDiscard = logBatch.length - exports.getMaxRecords();
                logBatch.splice(0, logsToDiscard);
            }
            return this.internalWriteLog(logBatch);
        };
        LogDatabaseStorage.prototype.getLogs = function (numberRows) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    return [2, this.db.executeReadTransaction(function (transaction) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var allLogs, limit, result;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, transaction.getAllRecords(LogTableInfo_1.default)];
                                    case 1:
                                        allLogs = _a.sent();
                                        limit = numberRows !== null && numberRows !== void 0 ? numberRows : allLogs.length;
                                        result = allLogs.slice(0, limit);
                                        return [2, this.dbRecordListToLogMessageList(result)];
                                }
                            });
                        }); }, false)];
                });
            });
        };
        LogDatabaseStorage.prototype.popLogs = function () {
            var _this = this;
            return this.db.executeTransaction(function (transaction) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var logsToPop;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, transaction.getAllRecords(LogTableInfo_1.default)];
                        case 1:
                            logsToPop = (_a.sent());
                            return [4, transaction.removeAllRecords(LogTableInfo_1.default)];
                        case 2:
                            _a.sent();
                            return [2, this.dbRecordListToLogMessageList(logsToPop)];
                    }
                });
            }); }, false);
        };
        LogDatabaseStorage.prototype.removeLogs = function (numberRowsToDelete) {
            var _this = this;
            return this.db.executeTransaction(function (transaction) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var allRecords;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, transaction.findRecords(LogTableInfo_1.default, {})];
                        case 1:
                            allRecords = (_a.sent());
                            return [4, Promise.all(allRecords
                                    .slice(0, numberRowsToDelete)
                                    .map(function (record) { return transaction.removeRecord(LogTableInfo_1.default, record.$KEY); }))];
                        case 2:
                            _a.sent();
                            return [2];
                    }
                });
            }); }, false);
        };
        LogDatabaseStorage.prototype.removeAllLogs = function () {
            var _this = this;
            return this.db.executeTransaction(function (transaction) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, transaction.removeAllRecords(LogTableInfo_1.default)];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); }, false);
        };
        LogDatabaseStorage.prototype.dbRecordListToLogMessageList = function (dbRecordList) {
            var _this = this;
            return dbRecordList.map(function (record) { return _this.dbRecordToLogMessage(record); });
        };
        LogDatabaseStorage.prototype.dbRecordToLogMessage = function (dbRecord) {
            return {
                instant: dbRecord[LogTableInfo_1.LOG_FIELDS.Instant],
                logType: dbRecord[LogTableInfo_1.LOG_FIELDS.LogType],
                message: dbRecord[LogTableInfo_1.LOG_FIELDS.Message],
                messageType: dbRecord[LogTableInfo_1.LOG_FIELDS.MessageType],
                moduleName: dbRecord[LogTableInfo_1.LOG_FIELDS.ModuleName],
                stack: dbRecord[LogTableInfo_1.LOG_FIELDS.Stack],
                extra: dbRecord[LogTableInfo_1.LOG_FIELDS.ExtraInfo] ? JSON.parse(dbRecord[LogTableInfo_1.LOG_FIELDS.ExtraInfo]) : undefined,
            };
        };
        return LogDatabaseStorage;
    }());
    exports.default = LogDatabaseStorage;
});
//# sourceMappingURL=LogDatabaseStorage.js.map;
